<template>
  <div class="container" id="referee_list_outer" v-if="refereeList != null">
    <h3 style="margin-top: 50px;">协会认证裁判员列表</h3>

    <div class="btn-toolbar" role="toolbar">
      <button type="button" :class="['btn','btn-default', {'active': (filterIndex == 0) }]" v-on:click="filterAllClicked">全部裁判员</button>
      <div class="btn-group">
        <button type="button" :class="['btn', 'btn-default', 'dropdown-toggle', {'active': (levelSecondName != null) }]" data-toggle="dropdown" >
          {{ levelSecondName != null ? levelSecondName : '按级别筛选' }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li v-for="(item, index) in levelFilters" :key="'level_' + index"><a href="javascript:void(0)" v-on:click="filterByLevel(index)" :class="{'active': (levelSecondName == item)}">{{item}}</a> </li>
        </ul>
      </div>

      <div class="btn-group">
        <button type="button" :class="['btn', 'btn-default', 'dropdown-toggle', {'active': (areaSecondName != null) }]" data-toggle="dropdown" >

          {{ areaSecondName != null ? areaSecondName : '按区域筛选' }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li v-for="(item, index) in areaFilters" :key="'level_' + index"><a href="javascript:void(0)" v-on:click="filterByArea(index)" :class="{'active': (areaSecondName == item)}">{{item}}</a> </li>
        </ul>
      </div>

      <div class="btn-group top-search">
        <el-input v-model="searchKeyword" placeholder="请输入内容" prefix-icon="el-icon-search" clearable>
          <el-button slot="append" @click="seachButtonClicked" >搜索</el-button>
        </el-input>
      </div>

    </div>
    <div v-if="refereeList.length > 0" class="list-view">
      <div class="referee-item" v-for="(item, index) in refereeList" :key="'referee-item' + index">
        <el-image v-if="item.headPortrait != null && item.headPortrait.length > 0" class="user-image" :src="item.headPortrait" />
        <el-image v-else class="user-image" fit="cover" :src="defaultHeaderImage(item)" />
        <div class="user-infors">
          <div class="nickname">{{item.name}}</div>
          <div v-if="isCompleted(item)" :class="['status-label', 'active']">本年度年审合格</div>
          <div class="other-subtitle">{{'裁判员等级：' + item.certificateLevel}}</div>
          <div class="other-subtitle">{{'所属区：' + item.area}}</div>
        </div>

        <a class="click-event" href="javascript:void(0)" v-on:click="openRefereeDetail(index)"></a>
      </div>

      <loading-view v-if="showBottomLoading" :index="loadingIndex" />

    </div>
    <div v-else class="none-data">
      暂无相关信息
    </div>

<!--    <a href="javascript:void(0);" v-on:click="openRefereeDetail(0)">裁判员详情</a>-->
  </div>
</template>

<script>
  import UserDefaultGoldImage from '../assets/shl_personal_head_portrait_gold_default.png'
  import userDefaultRedIcon from "../assets/shl_personal_head_portrait_red_default.png";
  import BottomLoadingView from "../components/common/BottomLoading.vue";
export default {
  name: "RefereeListPage",
  components: {
    'loading-view': BottomLoadingView,
  },
  data() {
    return {
      isLoading: false,
      refereeList: null,
      pageIndex: 0,
      pageSize: 12,
      filterIndex: 0,
      levelSecondName: null,
      areaSecondName: null,
      islastSearchKey: false,
      searchKeyword: '',
      showBottomLoading: false,
      loadingIndex: 0,
      isFirstLoading: false,

      levelFilters: [
        '国际级',
        '三人篮球国际级',
        '国家级',
        '荣誉裁判员',
        '一级',
      ],
      areaFilters: [
        '黄浦区',
        '静安区',
        '长宁区',
        '普陀区',
        '虹口区',
        '杨浦区',
        '浦东新区',
        '闵行区',
        '徐汇区',
        '宝山区',
        '嘉定区',
        '金山区',
        '松江区',
        '青浦区',
        '奉贤区',
        '崇明区',
        '学生体协',
        '上海体院',
        '其他行业体协'
      ],
      registerScrollListener: false,
    }
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
  },

  mounted() {
    this.isFirstLoading = true;
    this.loadData();
    this.addScrollListener();
  },

  destroyed() {
    this.removeScrollListener();
  },
  methods: {
    seachButtonClicked() {
      let keyword = this.searchKeyword.removeNamesBlank();
      this.pageIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.islastSearchKey = true;
      this.loadData();
    },

    isCompleted(item) {
      let status = item.status;
      let staminaTest = item.staminaTest;
      let theoryTest = item.theoryTest;
      let bothTrue = false;
      if (staminaTest == '已通过' && theoryTest == '已通过') {
        bothTrue = true;
      }
      if ((status == 5 && bothTrue) || status == 6) {
        let isValid = this.isDateValid(item);
        if (isValid) {
          return true;
        }
      }
      return false;
    },

    isVip(item) {
      if (item == null) {
        return false;
      }
      let member = item.isMember;
      if (member != undefined && member > 0) {
        return true;
      }
      return false;
    },

    defaultHeaderImage(item) {
      return this.isVip(item) ? UserDefaultGoldImage : userDefaultRedIcon;
    },
    addScrollListener() {
      window.onscroll = this.scrollListener;
      this.registerScrollListener = true;
    },

    removeScrollListener() {
      document.removeEventListener('mousewheel', this.scrollListener);
      this.registerScrollListener = false;
    },

    scrollListener: function(event) {
      this.loadMore();
    },

    getScrollTop() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    //获取当前可视范围的高度
    getClientHeight() {
      let clientHeight = 0;
      if(document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
      } else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
      }
      return clientHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    },

    loadMore() {
      if ( this.getScrollTop() + this.getClientHeight() + 50 - this.getScrollHeight() > 20 && !this.isLoading) {
        this.loadData();
      }
    },

    loadData() {
      if (this.isLoading || this.loadingIndex == 2) {
        return;
      }

      if (!this.registerScrollListener) {
        this.addScrollListener();
      }

      this.isLoading = true;
      if (!this.isFirstLoading) {
        this.showBottomLoading = true;
        this.loadingIndex = 1;
      } else {
        this.showBottomLoading = false;
      }
      let pageIndex = this.pageIndex;
      pageIndex += 1;
      let keyword = this.searchKeyword.removeNamesBlank();
      let params = {
        pageIndex,
        size: this.pageSize,
        keyword: keyword,
      };

      if (this.areaSecondName != null && this.areaSecondName.length > 0) {
        params.area = this.areaSecondName;
      }

      if (this.levelSecondName != null && this.levelSecondName.length > 0) {
        params.level = this.levelSecondName;
      }

      let _this = this;
      this.httpManager.ajax.getJudgeListData(params, function (data) {
        _this.isLoading = false;
        if (!_this.showBottomLoading) {
          _this.showBottomLoading = true;
        }
        let code = data.code;
        if (code == 0) {
          let itemArray = data.data;
          if (pageIndex == 1) {
            _this.refereeList = [];
          }

          if (itemArray.length > 0) {
            _this.refereeList = _this.refereeList.concat(itemArray);
            _this.pageIndex += 1;
            if (itemArray.length == _this.pageSize) {
              _this.loadingIndex = 0;
            } else {
              _this.loadingIndex = 2;
            }
          } else {
            _this.loadingIndex = 2;
            _this.removeScrollListener();
          }
          return;
        }
        _this.loadingIndex = 0;
        _this.$toast("数据加载失败");
      },function (data) {
        _this.loadingIndex = 0;
        _this.isLoading = false;
        _this.$toast("数据加载失败，请刷新！");
      })
    },

    isDateValid(item) {
     if (item != null) {
       return !(item.reviewed == 0);
     }
      return false;
    },

    openRefereeDetail: function (index) {
      let item = this.refereeList[index];
      if (item.reviewed == 0) {
        this.$toast("正在年检，无法查看！");
        return;
      }
      console.log(item);
      let id = item.id;
      this.$router.push({
        name: 'detailVue',
        params: {
          refereeId: id
        }
      });
    },
    filterAllClicked: function () {
      if (this.filterIndex == 0 && !this.islastSearchKey) {
        return;
      }
      this.pageIndex = 0;
      this.filterIndex = 0;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.islastSearchKey = false;
      this.searchKeyword = '';
      this.areaSecondName = null;
      this.levelSecondName = null;
      this.refereeList = null;
      this.loadData();
    },
    filterByArea: function (index) {
      let name = this.areaFilters[index];
      if (!this.islastSearchKey && this.filterIndex == 2 && name == this.areaSecondName ) {
        return;
      }

      this.pageIndex = 0;
      this.searchKeyword = '';
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.islastSearchKey = false;
      this.filterIndex = 2;
      this.areaSecondName = name;
      this.refereeList = null;
      this.loadData();
    },
    filterByLevel: function (index) {
      let name = this.levelFilters[index];
      if (!this.islastSearchKey && this.filterIndex == 1 && name == this.levelSecondName ) {
        return;
      }
      this.pageIndex = 0;
      this.filterIndex = 1;
      this.showBottomLoading = false;
      this.loadingIndex = 0;
      this.searchKeyword = '';
      this.islastSearchKey = false;
      this.levelSecondName = this.levelFilters[index];
      this.refereeList = null;
      this.loadData();
    }
  }
}
</script>

<style scoped>

  #referee_list_outer .btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    border: solid 1px #fc1a34;
    margin-left: 0px;
    border-bottom: 0px;
    padding-top: 5px;
  }


  #referee_list_outer .top-search {
    width: 250px;
    height: 45px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: solid 1px #FC1A34;
    border-radius: 4px;
    margin-bottom: 5px;
  }
  #referee_list_outer .top-search .el-input {
    height: 100%;
  }

  #referee_list_outer .top-search .el-input .el-button {
    background-color: #FC1A34;
    color: white;
    height: 100%;
    font-size: 15px;
  }
  #referee_list_outer .top-search .el-input .el-button:hover, #referee_list_outer .top-search .el-input .el-button:focus {
    color: #eee;
  }

  #referee_list_outer .top-search /deep/ .el-input__inner, #referee_list_outer .top-search .el-textarea__inner {
    height: 100%;
    border: none;
  }


  #referee_list_outer .btn-toolbar .btn-default {
    border: solid 1px #fc1a34;
    margin-bottom: 5px;
    padding: 7px 5px;
  }

  @media screen and (min-width: 613px){

    #referee_list_outer .top-search {
      width: 250px;
      height: 45px;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: solid 1px #FC1A34;
      border-bottom: none;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: 0px;
    }

    #referee_list_outer .btn-toolbar {
      display: block;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 30px;
      border: none;
      margin-left: 0;
      padding-top: 0;
    }

    #referee_list_outer .btn-toolbar .btn-default {
      border: solid 1px #fc1a34;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      margin-bottom: 0px;
      padding: 10px 7px;
      margin-left: 0;
    }
    #referee_list_outer .btn-toolbar > *:not(:first-child) {
      margin-left: 2px;
    }
  }

  @media screen and (min-width: 768px){
    #referee_list_outer .btn-toolbar > *:not(:first-child) {
      margin-left: 5px;
    }

    #referee_list_outer .btn-toolbar .btn-default {
      padding: 10px 15px;
    }
  }

  #referee_list_outer .btn-toolbar .btn-default:hover {
    color: #fc1a34;
  }

  #referee_list_outer .btn-toolbar .btn-default.active {
    background-color: white;
    color: #fc1a34;
  }

  #referee_list_outer .btn-toolbar .btn-default {
    font-size: 1.2rem;
  }

  #referee_list_outer .btn-toolbar .dropdown-menu li > a:hover {
    color: #fc1a34;
  }

  #referee_list_outer .btn-toolbar .dropdown-menu li > a.active {
    color: #fc1a34;
  }

  #referee_list_outer .list-view {
    border: solid 1px #fc1a34;
    padding-bottom: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
  }

  #referee_list_outer .none-data {
    height: 150px;
    font-size: 1.5rem;
    color: #666;
    line-height: 150px;
    border: solid 1px #fc1a34;

  }

  #referee_list_outer .referee-item {
    position: relative;
    border: solid 1px #fc1a34;
    height: 160px;
    min-width: 220px;
    width: 90%;
    margin-top: 15px;
    text-align: left;
    padding: 5px 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  .referee-item .user-image {
    width: 80px;
    height: 80px;
    background-color: white;
    border-radius: 50px;
  }


  .referee-item .click-event {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    text-decoration: none;
    /*background-color: rgba(0, 255, 0, 0.3);*/
  }

  .referee-item .user-infors {
    margin-left: 15px;
    /*background-color: yellow;*/
  }

  .referee-item .user-infors > div:not(:first-child) {
    margin-top: 4px;
  }

  .user-infors .nickname {
    font-size: 1.4rem;
    color: #333;
  }

  .user-infors .status-label {
    font-size: smaller;
    color: gray;
    border: solid 1px gray;
    text-align: center;
    margin-top: 3px;
    vertical-align: middle;
  }

  .user-infors .status-label.active {
    color: green;
    border: solid 1px green;
  }

  .user-infors .other-subtitle {
    font-size: smaller;
    color: #333;
  }


  @media screen and (min-width: 320px) {
    #referee_list_outer .referee-item {
      padding: 5px 10px;
      min-width: 280px;
      width: 90%;
    }

    .referee-item .user-infors {
      margin-left: 15px;
    }
    .referee-item .user-image {
      width: 120px;
      height: 120px;
      border-radius: 60px;
    }

  }

  #referee_list_outer .btn-default:focus {
    color: white;
  }

  @media screen and (min-width: 768px) {
    #referee_list_outer .referee-item {
      width: 45%;
      margin-left: 3.33%;
      justify-content: flex-start;
    }

    #referee_list_outer .list-view {
      justify-content: flex-start;
    }
  }

  @media screen and (min-width: 1000px) {
    #referee_list_outer .referee-item {
      width: 30%;
      margin-left: 2.5%;
    }
    #referee_list_outer .list-view {
      justify-content: flex-start;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/RefereeListPage.vue